module.exports = __webpack_public_path__ + "7120f405f94a79633cb8671daf076264.otf";